<template>
  <div class="bg-white p-4">
    <dashboard-bar refreshButton />
    <div class="row mb-1">
      <div class="col-12">
        <div class="header">
          <span class="header-icon">
            <i class="fa fa-upload" aria-hidden="true"></i>
          </span>
          <h2>{{ $t('uploads.pageTitle') }}</h2>
        </div>
      </div>
    </div>
    <div>
      <div class="row">
        <div class="col-8 header-filters mt-2">
          <div class="filters-area">
            <label><strong>Pesquisar por</strong></label>
            <div class="filter-type">
              <b-form-select
                v-model="filterType"
                @change="setFilterType"
                :options="filterTypeOptions"
              ></b-form-select>
            </div>
          </div>

          <div class="form-inline mb-3">
            <div class="form-group mt-3 pl-0 pr-0">
              <input
                style="width: 100%"
                type="text"
                class="form-control"
                :placeholder="$t('clients.searchInput')"
                @keyup="searchUploads"
                v-model="search"
              />
            </div>
            <button
              @click="
                search = null;
                searchUploads();
              "
              type="button"
              class="btn btn-outline-primary mt-3 ml-1"
            >
              {{ $t('clients.searchButton') }}
            </button>
          </div>
        </div>
        <div
          class="col-4 text-right button-upload"
          style="padding-bottom: 10px"
        >
          <button type="button" class="btn btn-primary" v-b-modal.modalUpload>
            + {{ $t('uploads.sendFile') }}
          </button>
          <b-modal
            id="modalUpload"
            :title="`${this.$t('uploads.modalTitle')}`"
            size="xl"
            @ok="uploadFile(fileToUpload)"
          >
            <div class="col-12" style="display: flex">
              <div class="col-6">
                <div class="row mb-2">
                  <div class="col-12">
                    <label for="selectedBranch"
                      >{{ $t('uploads.branchLabel') }}:</label
                    >
                    <b-form-select
                      v-model="mySelectedBranch"
                      :options="branchList"
                    ></b-form-select>
                  </div>
                  <div class="col-12">
                    <div class="pull-right"></div>
                  </div>
                </div>
                <!--
                <div class="row mb-2">
                  <div class="col-12">
                    <label for="selectedAction"
                      >{{ $t('uploads.actionLabel') }}:</label
                    >
                    <b-form-select
                      id="reference"
                      v-model="mySelectedAction"
                      @change="changedAction"
                      :options="actionList"
                    ></b-form-select>
                  </div>
                  <div class="col-12">
                    <div class="pull-right"></div>
                  </div>
                </div>
                -->
                <div class="row mb-2">
                  <div class="col-12">
                    <label for="selectedReference"
                      >{{ $t('uploads.selectReferenceLabel') }}:</label
                    >
                    <b-form-select
                      id="selectedReference"
                      v-model="referenceSelectedOption"
                      :options="referenceOptions"
                    ></b-form-select>
                  </div>
                  <div class="col-12">
                    <div class="pull-right"></div>
                  </div>
                </div>
                <div class="row mb-2">
                  <div class="col-12">
                    <label for="reference"
                      >{{ $t('uploads.referenceLabel') }}:</label
                    >
                    <input
                      id="reference"
                      class="form-control"
                      type="text"
                      v-model="reference"
                      :placeholder="$t('uploads.referenceLabel')"
                    />
                  </div>
                  <div class="col-12">
                    <div class="pull-right"></div>
                  </div>
                </div>
                <!-- <div v-if="mySelectedAction" class="row mb-2">  -->
                <div class="row mb-2">
                  <div class="col-12">
                    <label for="selectFile">
                      {{ $t('uploads.fileLabel') }}:
                    </label>
                    <b-form-file
                      :placeholder="$t('uploads.selectPlaceholder')"
                      :browse-text="$t('uploads.selectLabel')"
                      :drop-placeholder="$t('uploads.dropPlaceholder')"
                      id="selectFile"
                      ref="file-input-upload"
                      accept=".txt,.xls,.xlsx,.csv"
                      @change="selectUploadFile(filename, $event.target.files)"
                    >
                    </b-form-file>
                  </div>
                </div>
              </div>
              <div class="col-6 mt-4">
                <b>{{ $t('uploads.notificationTitle') }}</b>
                <p>{{ $t('uploads.notificationText') }}</p>
              </div>
            </div>
          </b-modal>
        </div>
      </div>
      <b-table v-if="branchList.length" striped :items="items" :fields="fields" :busy="loading">
        <template v-slot:table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner type="grow" class="align-middle"></b-spinner>
          </div>
        </template>
        <template v-slot:cell(branchId)="row">
          <div>
            {{ getBranchName(row.item.branchId) }}
          </div>
        </template>

        <!--
        <template v-slot:cell(actionId)="row">
          <div>
            {{ getActionName(row.item.actionId) }}
          </div>
        </template>
        -->
        <template v-slot:cell(createdAt)="row">
          <div>
            {{ dateFormat(row.item.createdAt) }}
          </div>
        </template>
        <template v-slot:cell(options)="row">
          <button
            :title="$t('uploads.uploadsTable.labels.remove')"
            class="btn btn-outline-danger"
            @click="removeUpload(row.item._id, row.item.fileId)"
          >
            <i class="fas fa-eraser"></i>
          </button>
          <button
            :title="$t('uploads.uploadsTable.labels.download')"
            class="btn btn-outline-primary"
            @click="downloadUpload(row.item.fileId, row.item.filename)"
          >
            <i class="fas fa-download"></i>
          </button>
        </template>
      </b-table>
    </div>
    <div class="pagination-area-clients mt-1">
      <paginate
        v-model="page"
        :clickHandler="getUploads"
        :pageCount="Math.ceil(total / 10)"
        :prevText="'‹'"
        :nextText="'›'"
        :activeClass="'active'"
        :containerClass="'pagination b-pagination'"
        :pageClass="'page-item'"
      ></paginate>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Paginate from 'vuejs-paginate';
import { format } from 'date-fns';
import swal from 'sweetalert';
import XLSX from 'xlsx';
import api from '@/services/api';
import loader from '@/components/atoms/loader-download';
import dashboardBar from '@/components/molecules/dashboard-bar';
import EventBus from '../../../eventBus';

export default {
  components: {
    Paginate,
    loader,
    dashboardBar,
  },

  data: () => ({
    filterSelectedOptions: [],
    filterType: 'controlId', // default
    filterTypeOptions: [],
    loading: false,
    userAuth: null,
    total: 0,
    page: 1,
    limit: 10,
    fields: [],
    items: [],
    typingTimer: null,
    doneTypingInterval: 600,
    search: null,
    filename: null,
    newFilename: null,
    fileToUpload: null,
    branchList: [],
    mySelectedBranch: null,
    reference: null,
    referenceSelectedOption: null,
    referenceOptions: [],
    actionList: [],
    // mySelectedAction: null,
    mySelectedAction: 0,
    validFile: false,
  }),

  watch: {
    calendarDates: function watchCalendarDates() {
      this.refreshTable();
    },
    myIh1: function watchMyIh1(value) {
      this.refreshTable();
    },
  },
  computed: {
    ...mapState('calendar', ['calendarDates']),
    ...mapState('branches', ['ih1', 'ih2', 'myIh1', 'myIh2']),
    ...mapState('indicators', ['actionIndicators']),
  },
  methods: {
    ...mapActions('indicators', ['getIndicators']),
    dateFormat(data) {
      return format(new Date(data), 'dd/MM/yyyy HH:mm');
    },

    setFilterType(value) {
      this.filterType = value;
    },

    changeLabels() {
      this.fields = [
        {
          key: 'controlId',
          label: this.$t('uploads.uploadsTable.labels.id'),
        },
        { key: 'userName', label: this.$t('uploads.uploadsTable.labels.user') },
        {
          key: 'branchId',
          label: this.$t('uploads.uploadsTable.labels.branch'),
        },
        { key: 'filename', label: this.$t('uploads.uploadsTable.labels.file') },
        /*
        {
          key: 'actionId',
          label: this.$t('uploads.uploadsTable.labels.action'),
        },
        */
        {
          key: 'reference',
          label: this.$t('uploads.uploadsTable.labels.reference'),
        },
        {
          key: 'createdAt',
          label: this.$t('uploads.uploadsTable.labels.date'),
        },
        {
          key: 'options',
          label: this.$t('uploads.uploadsTable.labels.options'),
        },
      ];

      this.filterTypeOptions = [
        {
          text: this.$t('answers.filterTypeOptions.id'),
          value: 'controlId',
        },
        {
          text: this.$t('answers.filterTypeOptions.name'),
          value: 'filename',
        },
        {
          text: this.$t('uploads.uploadsTable.labels.reference'),
          value: 'reference',
        },
        {
          text: this.$t('uploads.uploadsTable.labels.branch'),
          value: 'filial',
        },
      ];

      this.referenceOptions = [
        this.$t('uploads.referenceSales'),
        this.$t('uploads.referenceAftersales'),
      ];
    },
    async getUploads() {
      try {
        this.loading = true;
        const response = await api.get(`uploads/${this.userAuth.companyId}`, {
          headers: { 'x-access-token': this.userAuth.token },
          params: {
            page: this.page,
            limit: this.limit,
            search: this.search,
            searchType: this.filterType,
            branch: this.myIh1,
          },
        });
        this.items = response.data.uploads;
        this.total = response.data.total;
      } catch (error) {
        swal({
          title: this.$t('uploads.errorTitle'),
          text: error.response.data.message,
          icon: 'error',
        });
      }
      this.loading = false;
    },
    async refreshTable() {
      this.page = 1;
      await this.getUploads();
    },
    async searchUploads() {
      if (this.search !== '' && this.search !== null) {
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(
          this.refreshTable,
          this.doneTypingInterval,
        );
      }

      if (this.search === '' || this.search === null) {
        this.search = null;
        this.refreshTable();
      }
    },

    async createNewUpload(fileToUpload, newFilename) {
      try {
        this.loading = true;
        const response = await api.post(
          'uploads',
          {
            companyId: this.userAuth.companyId,
            userId: this.userAuth._id,
            branchId: this.mySelectedBranch,
            actionId: this.mySelectedAction,
            filename: fileToUpload.name,
            fileId: newFilename,
            reference: `${this.referenceSelectedOption} - ${this.reference}`,
          },
          { headers: { 'x-access-token': this.userAuth.token } },
        );
        this.items = response.data.uploads;
        this.total = response.data.total;
      } catch (error) {
        swal({
          title: this.$t('uploads.errorTitle'),
          text: error.response.data.message,
          icon: 'error',
        });
      }
      this.loading = false;
    },
    async sendToS3(file) {
      const formData = new FormData();
      formData.append('file', file);

      const response = await api.post('uploads/upload-file', formData, {
        headers: {
          'x-access-token': this.userAuth.token,
          'Content-Type': 'multipart/form-data',
        },
      });

      return response.data;
    },
    async changedAction() {
      await this.getIndicators({
        token: this.userAuth.token,
        actionId: this.mySelectedAction,
      });
    },
    selectUploadFile(filename, files) {
      if (files[0].type && files[0].type === 'text/csv' || files[0].type === 'text/plain'
      || files[0].type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      || files[0]. type === 'application/vnd.ms-excel') {
        this.fileToUpload = files[0];
      } else {
        this.$refs['file-input-upload'].reset();

        swal({
          title: 'Atenção!',
          text: 'Aceitamos apenas arquivos que sejam .txt .xls, .xlsx e .csv',
          icon: 'warning',
        });
      }
      // this.validateFile(this.fileToUpload); // ativar validação!!!!!
    },
    async uploadFile(fileToUpload) {
      if (
        // !this.validFile ||
        !this.mySelectedBranch ||
        !this.referenceSelectedOption ||
        // !this.mySelectedAction ||
        !this.reference ||
        !this.fileToUpload
      ) {
        swal({
          title: this.$t('uploads.errorTitle'),
          text: this.$t('uploads.fillFields'),
          icon: 'error',
        });
        return;
      }
      const fileName = await this.sendToS3(fileToUpload);
      await this.createNewUpload(fileToUpload, fileName);
      swal(this.$t('uploads.uploadOk'), {
        icon: 'success',
      });
      this.refreshTable();
    },
       getBranchName(branchId) {
       const name = this.branchList.find((item) => item.value === branchId);
      if (name) {
        return name.text;
      }
      return null;
    },
    async removeUpload(id, fileId) {
      swal({
        title: this.$t('uploads.removeUpload.title'),
        text: this.$t('uploads.removeUpload.description'),
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      }).then(async (willDelete) => {
        if (willDelete) {
          this.loading = true;
          try {
            await Promise.all([
              api.delete(`uploads/${id}`, {
                headers: { 'x-access-token': this.userAuth.token },
              }),
              api.delete(`uploads/delete-file/${fileId}`, {
                headers: { 'x-access-token': this.userAuth.token },
              }),
            ]);
          } catch (error) {
            swal({
              title: this.$t('uploads.errorTitle'),
              text: error.response.data.message,
              icon: 'error',
            });
          }
          await this.refreshTable();
          this.loading = false;
          swal(this.$t('uploads.removeUpload.ok'), {
            icon: 'success',
          });
        }
      });
    },
    downloadUpload(id, filename) {
      const link = document.createElement('a');
      link.href = `https://indecxupload.s3.amazonaws.com/${this.userAuth.companyId}/${id}`;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
    },
    async validateFile(file) {
      this.validFile = false;
      const reader = new FileReader();
      try {
        await reader.readAsArrayBuffer(file);
        reader.onload = (e) => {
          const data = new Uint8Array(e.target.result);
          const arr = [];
          for (let i = 0; i !== data.length; i += 1) {
            arr[i] = String.fromCharCode(data[i]);
          }
          const bstr = arr.join('');
          const workbook = XLSX.read(bstr, {
            type: 'binary',
          });
          const firstSheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[firstSheetName];
          const json = XLSX.utils.sheet_to_json(worksheet, {
            raw: true,
          });
          const fileIndicators = [];
          let idx = 0;
          // eslint-disable-next-line
          for (let propriedade in json[0]) {
            if (idx > 2) {
              fileIndicators.push(propriedade);
            }
            idx += 1;
          }
          if (fileIndicators.length === this.actionIndicators.length) {
            this.validFile = true;
            for (let i = 0; i < fileIndicators.length; i += 1) {
              if (fileIndicators[i] !== this.actionIndicators[i].key) {
                this.validFile = false;
                break;
              }
            }
          }
          if (!this.validFile) {
            swal({
              title: this.$t('uploads.errorTitle'),
              text: this.$t('uploads.indicatorsError'),
              icon: 'error',
            });
          }
        };
      } catch (err) {
        window.console.log(err);
      }
    },
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.changeLabels();
  },

  async mounted() {
    EventBus.$on('changedLanguage', () => {
      this.changeLabels();
    });

    await this.getUploads();

    const response = await api.get(`/branches/${this.userAuth.companyId}`, {
      headers: { 'x-access-token': this.userAuth.token },
      params: {
        companyId: this.userAuth.companyId,
        token: this.userAuth.token,
        type: 'ih1',
      },
    });

    // create select list for branches
    this.branchList = response.data.branches.map((a) => {
      return {
        value: a._id,
        text: a.corporate_name,
      };
    });
    // create select list for actions
    for (let i = 0; i < this.$store.state.actions.allActions.length; i += 1) {
      this.actionList.push({
        value: this.$store.state.actions.allActions[i]._id,
        text: this.$store.state.actions.allActions[i].name,
      });
    }
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
@import '@/themes/default/placeholders.scss';
.filters-area {
  margin-bottom: 32px;
}

.header-filters {
  display: flex;
  justify-content: left;
  align-items: center;
}

.button-upload {
  display: flex;
  justify-content: right;
  align-items: center;
}

.filter-type {
  display: flex;
  flex-direction: row;
  max-width: 150px;
  margin-right: 10px;
}

h2 {
  text-transform: uppercase;
  font-size: 21px;
  font-weight: 100;
  color: $gray;
}

.header {
  display: flex;
  flex-direction: row;

  .header-icon {
    float: left;
    font-size: 12px;
    margin-top: 4px;
    padding-right: 12px;
    color: $gray;
  }

  .refresh-icon {
    margin-top: 1px;
    color: $primary;
    cursor: pointer;
    &:hover {
      color: green;
    }
  }
}

.flag-status {
  padding: 0.2rem;
  font-size: 0.8rem;
  border-radius: 0.25rem;
  color: $white;
  width: 100px;
  text-align: center;
  opacity: 0.9;
}

.flag-status-concluido {
  background-color: #28a745;
}

.flag-status-processando {
  background-color: #ffc107;
}

.flag-status-expirado {
  background-color: $gray;
}

.flag-status-falha {
  background-color: red;
}

.download-icon {
  padding: 5px 15px;
  background: #28a745;
  color: $white;
  border-radius: 10px;
  font-size: 15px;
  border: none;
}

.download-icon:hover {
  cursor: pointer;
}

.pagination-area-clients >>> a {
  position: relative;
  display: block;
  padding: 0.5rem 0.75rem;
  margin-left: -1px;
  line-height: 1.25;
  color: #4ce595;
  background-color: #fff;
  border: 1px solid #dee2e6;
}
</style>

<style>
.pagination-area-clients .active a {
  text-decoration: none;
  z-index: 1;
  color: #fff;
  background-color: #4ce595;
  border-color: #4ce595;
}

.pagination-area-clients a {
  outline: none;
}

.custom-row {
  display: flex;
  align-items: center;
}

.custom-row > * {
  margin-right: 1rem;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/upload/index.vue